import styled from 'styled-components';

export const UploadWrap = styled.div`
	& img {
		width: 50px;
		height: 50px;
		border-radius: 50%;
	}
`;
